 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"1c9a35c66c5077301e1e2d2e8be6c857c2714536","2":"f8c148c6eb458b6489b2659d1b4722442cd4679a","3":"99ea7e0f1ad0456a7414739b4a9774e58c98ba49","4":"a2267787","5":"d91e9ae9","6":"ff239f9d","7":"3c1851618f9669e229033f5d29fb7997caad13aa","8":"4f4c1d690412efbc33df260c09c2d5ba084d24bb","9":"0c570e9209107be251f9b6efc7fce03555358757","10":"ea88be26","11":"e07039c301291d4deb9817e7b8da4ebc2b0f88d0","12":"2798ec4929c5811f94933331ab524d26502e3308","13":"component---src-pages-product-detail-option-panel-index-js","14":"a17b2982a9f0f8a9248995397c052d280bce80d2","15":"b16726c80ffa0831827b3bd737ad8883f1374585","16":"component---src-pages-product-detail-index-js","19":"component---src-pages-404-js","20":"component---src-pages-email-verification-js","21":"component---src-pages-index-js","22":"component---src-pages-product-detail-add-to-cart-segment-index-js","23":"component---src-pages-product-detail-faq-index-js","24":"component---src-pages-product-detail-option-panel-control-type-2-index-js","25":"component---src-pages-product-detail-option-panel-control-type-3-index-js","26":"component---src-pages-product-detail-option-panel-control-type-4-index-js","27":"component---src-pages-product-detail-product-header-panel-index-js","28":"component---src-templates-brand-js","29":"component---src-templates-campaign-detail-page-js","30":"component---src-templates-campaign-page-js","31":"component---src-templates-contact-js","32":"component---src-templates-cookie-policy-js","33":"component---src-templates-landing-page-js","34":"component---src-templates-member-permission-text-js","35":"component---src-templates-permission-text-js","36":"component---src-templates-product-js","37":"component---src-templates-razer-gold-campaign-js","38":"component---src-templates-survey-page-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"f14e37f340517bede473","2":"8d226fb2ce82a2ab1a1c","3":"1ecb3dd94f96958310e8","4":"1800ad858fa2427ec78d","5":"c4d1aa4eda76636d0304","6":"9770ec760ca43029cb82","7":"1386b5abebc5fc2e9b26","8":"c5ca05ff49edab34de8f","9":"4a93a2fea2af5e4195c7","10":"802dba0da54ba135fdf3","11":"84f5f1a9ec8b820509e2","12":"85252680a914035730dc","13":"a2dbe2cb5e7565905ae5","14":"162b3fce799ae05a0505","15":"26206a8108d5745c4367","16":"88683e5c85a5350c031a","19":"1f62c2cd5fec8da1c9a7","20":"51357cf9cab7540600ab","21":"9c21d8ccb4e6c149cb9b","22":"16b591a0f874b765e2c5","23":"0831df5c0af7f6d97a38","24":"35653d04bb7a6996314d","25":"9a1696ec26f02350a4e5","26":"1f3b10f3468f41769e56","27":"7fe3fa9077b15a5c1699","28":"1ecf1900c644af1af749","29":"819131826d97621def01","30":"96b6ff4f7233a2387f9d","31":"02074319e7f0d3d9f689","32":"993270586343a4c27392","33":"04861d1c68e2a66b0043","34":"70c5517bdeeac062aaeb","35":"b4c405893ff733f3390c","36":"024645184dc33c2b52aa","37":"76b1cf3c8066acf7c7ec","38":"b82814f02c5adfe88ee4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"1c9a35c66c5077301e1e2d2e8be6c857c2714536","2":"f8c148c6eb458b6489b2659d1b4722442cd4679a","3":"99ea7e0f1ad0456a7414739b4a9774e58c98ba49","4":"a2267787","5":"d91e9ae9","6":"ff239f9d","7":"3c1851618f9669e229033f5d29fb7997caad13aa","8":"4f4c1d690412efbc33df260c09c2d5ba084d24bb","9":"0c570e9209107be251f9b6efc7fce03555358757","10":"ea88be26","11":"e07039c301291d4deb9817e7b8da4ebc2b0f88d0","12":"2798ec4929c5811f94933331ab524d26502e3308","13":"component---src-pages-product-detail-option-panel-index-js","14":"a17b2982a9f0f8a9248995397c052d280bce80d2","15":"b16726c80ffa0831827b3bd737ad8883f1374585","16":"component---src-pages-product-detail-index-js","19":"component---src-pages-404-js","20":"component---src-pages-email-verification-js","21":"component---src-pages-index-js","22":"component---src-pages-product-detail-add-to-cart-segment-index-js","23":"component---src-pages-product-detail-faq-index-js","24":"component---src-pages-product-detail-option-panel-control-type-2-index-js","25":"component---src-pages-product-detail-option-panel-control-type-3-index-js","26":"component---src-pages-product-detail-option-panel-control-type-4-index-js","27":"component---src-pages-product-detail-product-header-panel-index-js","28":"component---src-templates-brand-js","29":"component---src-templates-campaign-detail-page-js","30":"component---src-templates-campaign-page-js","31":"component---src-templates-contact-js","32":"component---src-templates-cookie-policy-js","33":"component---src-templates-landing-page-js","34":"component---src-templates-member-permission-text-js","35":"component---src-templates-permission-text-js","36":"component---src-templates-product-js","37":"component---src-templates-razer-gold-campaign-js","38":"component---src-templates-survey-page-js"}[chunkId]||chunkId) + "." + {"0":"0cf706f304088938c4ca","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
